<div class="row">
  <div class="col-md-12">
    <!--
    <div mat-dialog-title class="row">
      <div class="col-md-12">
        <strong>Would you like to proceed?</strong>
      </div>
    </div>
    -->
    <div mat-dialog-content class="row">
      <div class="col-md-12">
        <div class="row">
          <div class="col-md-12">
            <p>The Zipcode has been changed to {{ data.address1_PostalCode }} after standardizing the address.</p>
          </div>
        </div>
      </div>
    </div>
    <div mat-dialog-actions class="row">
      <div class="col-md-12" style="text-align: center;">
        <button
          mat-raised-button
          (click)="onClickClose()">
            Ok
        </button>
      </div>
    </div>
  </div>
</div>
